import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export interface ReportViewActivity {
  viewed_at: string;
  viewed_from: 'admin' | 'partner';
  filters_applied?: Array<{ field: string; label: string; value: unknown; at: string }>;
  sorts_applied?: Array<{ field: string; label: string; direction: string; at: string }>;
  exports?: Array<{ format: string; at: string }>;
}

export default class ReportTrackingModel extends Model {
  @attr declare reportId: string;
  @attr declare reportViewActivity: ReportViewActivity;
  @attr declare browserMeta: Record<string, string>;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  [Type] = 'report-tracking' as const;
}
